import React, { act, useEffect, useState } from "react";
import { useAuth } from "../../auth/FirebaseAuth";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import Space from "../../layout/Space";

import PrimaryButton from "../../buttons/PrimaryButton";
import { useSnackbar } from "notistack";
import MemberModal from "../../modals/MemberModal.js";
import Modal1 from "../../modals/Modal1.js";
import MemberColorModal from "../../modals/MemberColorModal.js";
import { useAppContext } from "../../config/AppContext";
import {
  getArrayDocDataByID,
  getArrayDocDataByRef,
  getDocDataById,
  getOrgDataById,
  queryCollection,
  updateDocDataField,
} from "../../models/DataFunctions";

import SecondaryButton from "../../buttons/SecondaryButton";

import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken.js";
import updateDocDataFieldApi from "../../api/database/updateDocDataFieldApi.js";

import { SaveBar, ToggleSettingsBrick } from "../../textfields/EasySwitch";
import TextField2T from "../../textfields/TextField2T";
import TabGPT from "../../tabs/TabGPT";
import SmallSpinner from "../../loading/SmallSpinner.js";

import { File, Org, OrgInfos, User } from "../../types/basicTypes.js";
import DropDownGPT03 from "../../dropdown/DropDownGTP03.js";
import Icon1 from "../../assets/icons/Icon.js";
import updateDocApi from "../../api/database/updateDocApi";
import uploadFiles from "../../api/upload/uploadFiles";
import { Spin } from "antd";
import createNewMember from "../../api/create/createNewMember";
import sendInvite from "../../api/send/sendInvite";

type OrganisationProps = {
  userData: User;
  orgData: Org;
  navigateWorkspace: (path: string) => void;
  handleClickVariant: (
    message: string,
    variant: "default" | "error" | "success" | "warning" | "info" | undefined
  ) => void;
};

const Organisation = ({
  userData,
  orgData,
  navigateWorkspace,
  handleClickVariant,
}: OrganisationProps) => {
  const { currentUser, loading } = useAuth();

  // get the tab parameter from the URL
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab");

  const { enqueueSnackbar } = useSnackbar();
  const [infos, setInfos] = useState<OrgInfos | undefined>(undefined);

  const [users, setUsers] = useState<User[]>([]);
  const [signatures, setSignatures] = useState([]);
  const [tampons, setTampons] = useState([]);

  const [email, setEmail] = useState("");
  const [email2, setEmail2] = useState("");
  const [tabs, setTabs] = useState<any[]>([
    {
      id: "infos",
      label: "Informations",
    },
    {
      id: "members",
      label: "Membres",
    },
  ]);
  const [activeTab, setActiveTab] = useState(tab ? tab : "infos");
  const [name, setName] = useState("");
  const [userType, setUserType] = useState(null);

  const [loadingFile, setLoadingFile] = useState(false);

  const [new_email, setNewEmail] = useState("");

  // Fonction pour récupérer les données de l'organisation
  const handleFetchData = async () => {
    if (orgData) {
      try {
        let infoss = orgData.infos || {};
        setInfos(infoss); // Initialise les infos de l'organisation

        const users = (await queryCollection("user", [
          {
            field: "org_id",
            operator: "==",
            value: orgData.id,
          },
        ])) as User[];
        setUsers(users); // Initialise les employés de l'organisation
      } catch (error) {
        console.error(
          "Erreur lors de la récupération de l'organisation:",
          error
        );
      }
    }
  };
  const [dropped_files, setDroppedFiles] = useState([]);
  const [loadingDrop, setLoadingDrop] = useState(false);
  const [droppedExists, setDroppedExists] = useState(false);

  const handleSendInvite = async (user_id: string | undefined) => {
    if (!user_id) {
      handleClickVariant("Aucun utilisateur sélectionné", "error");
      return;
    }
    try {
      const token = await getOrRefreshFirebaseToken();
      let org = (await getDocDataById("org", orgData.id)) as Org;
      let users = await getArrayDocDataByID("user", org.users_id);

      let new_user = users.find((user) => user.id === user_id);
      if (!new_user) {
        handleClickVariant("Utilisateur non trouvé", "error");
        return;
      }
      await sendInvite(
        orgData.infos.name,
        new_user.email,
        orgData.id,
        token,
        prefix
      ); // Call the sendInvite API
      handleClickVariant("Invitation envoyée avec succès", "success");
    } catch (error) {
      handleClickVariant("Erreur lors de l'envoi de l'invitation", "error");
      console.error(error);
    }
  };

  useEffect(() => {
    handleFetchData(); // Récupère les données de l'organisation lorsque le composant est monté
  }, [orgData]);

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const saved_data = appState.saved_data;
  // Function to update the organization
  const callModifyMaster = async () => {
    if (!orgData) return; // Ensure orgData is available

    try {
      // Get the user's Firebase authentication token

      // Prepare the data to be sent for updating the organization
      // Call the API to modify the organization
      await updateDocApi(
        "org",
        orgData.id,
        {
          infos: infos,
        },
        prefix
      );
      // await updateDocDataFieldApi(orgData.ref, "infos", infos, prefix);
      // await updateDocDataFieldApi(
      //   orgData.ref,
      //   "name",
      //   infos.entreprise,
      //   prefix
      // );
      handleClickVariant("Organisation modifiée avec succès", "success");
      navigateWorkspace("/organisation"); // Navigate to the organizations page
    } catch (error) {
      handleClickVariant(
        "Erreur lors de la modification de l'organisation",
        "error"
      );
      console.error(error);
    }
  };

  const callSendInvite = async (already: boolean) => {
    if (!already && (!email || !name)) {
      handleClickVariant("Veuillez remplir tous les champs", "error");
      return;
    }

    let email_to_use = already ? email2 : email;

    const filters = [
      {
        field: "email",
        operator: "==",
        value: email_to_use.trim(),
      },
    ];
    const doublons = await queryCollection("user", filters);
    if (doublons.length > 0) {
      if (already) {
        handleClickVariant(
          "Cet utilisateur est déjà enregistré dans l'organisation",
          "error"
        );

        return;
      } else {
        handleClickVariant("Cet email est déjà utilisé", "error");
        return;
      }
    } else {
      if (already) {
        handleClickVariant("Cet email n'est pas enregistré", "error");
        return;
      }
    }

    try {
      let token = await getOrRefreshFirebaseToken();

      await sendInvite(
        orgData.infos.name,
        email_to_use,
        orgData.id,
        token,
        prefix
      ); // Call the sendInvite API
      handleClickVariant("Invitation envoyée avec succès", "success");
      setEmail("");
      setName("");
      setUserType(null);
      setAddMember(false);
    } catch (error) {
      handleClickVariant("Erreur lors de l'envoi de l'invitation", "error");
      console.error(error);
    }
  };
  const handleChangeLogo = async () => {
    const token = await getOrRefreshFirebaseToken();

    // make the user select a pdfr
    if (loadingFile) {
      return;
    }
    const input = document.createElement("input");
    input.type = "file"; // pdf
    input.accept = "image/*"; // accept only images
    input.onchange = (event) => {
      const file = (event.target as HTMLInputElement).files?.[0];
      if (file) {
        setLoadingFile(true);
        const reader = new FileReader();
        let file_name = file.name.replace(" ", "_");
        console.log("file_name", file_name);
        reader.onload = async (e) => {
          const newCertificat: File = {
            url: e.target?.result as string,
            name: file_name,
            id: `none`,
            octets: file.size,
          };
          let file_id = "orgs/" + orgData.id + "/logos/";
          const token = await getOrRefreshFirebaseToken();
          let fresh_files = await uploadFiles(
            [newCertificat],
            file_id,
            "logo",
            token,
            prefix
          );
          if (fresh_files && fresh_files.files.length > 0) {
            await updateDocDataFieldApi(
              orgData.ref!,
              "logo",
              fresh_files.files[0].url,
              prefix
            );
            // await uploadImage(orgData.id, token, prefix);

            setLoadingFile(false);
          }
        };
        reader.readAsDataURL(file);
      }
    };
    input.click();

    handleClickVariant("Logo modifié avec succès", "success");
    // I want the whole app to refresh
  };

  const handleMemberClick = async (
    user_id: string | undefined,
    isinfos: any
  ) => {
    const user = await getDocDataById("user", user_id);
    setMemberData(user);
    if (isinfos) {
      setMemberOpen(true);
    } else {
      setMemberColorOpen(true);
    }
  };

  const [memberData, setMemberData] = useState<User | undefined>(undefined);
  const [addMember, setAddMember] = useState(false);
  const [memberOpen, setMemberOpen] = useState(false);
  const [memberColorOpen, setMemberColorOpen] = useState(false);

  if (loading || !currentUser || !orgData || !infos) {
    return <div></div>; // Affiche un message de chargement
  }

  return (
    <div className="w-full h-full overflow-auto flex flex-col  ">
      <div className="w-full h-fit flex flex-col items-start justify-start ">
        {/* <Modal1 isOpen={memberOpen} onClose={() => setMemberOpen(false)}>
          <MemberModal
            onClose={() => setMemberOpen(false)}
            user_id={memberData?.id}
            onUpdate={handleFetchData}
            orgData={orgData}
          />
        </Modal1> */}
        {/* <Modal1
          isOpen={memberColorOpen}
          onClose={() => setMemberColorOpen(false)}
        >
          <MemberColorModal
            onClose={() => setMemberColorOpen(false)}
            user_id={memberData?.id}
            onUpdate={handleFetchData}
          />
        </Modal1> */}
        <Modal1 isOpen={addMember} onClose={() => setAddMember(false)}>
          <div className="flex flex-col w-fit gap-2 h-fit items-start justify-center bg-white p-4 rounded-xl">
            <div className="text-h2  text-left mb-2">
              Ajouter un nouveau membre
            </div>
            <div className="flex flex-col gap-2 w-fit">
              <TextField2T
                className="w-full text-left"
                label="Email"
                value={email}
                type="email"
                mandatory={true}
                onChange={(e) => setEmail(e.target.value)}
              />

              <TextField2T
                className="w-full text-left"
                label="Prénom nom"
                value={name}
                mandatory={true}
                onChange={(e) => setName(e.target.value)}
              />

              <Space y={10} />
              <div className="w-c500 flex flex-row justify-end gap-2">
                <SecondaryButton onClick={() => setAddMember(false)}>
                  Annuler
                </SecondaryButton>

                <PrimaryButton
                  onClick={() => callSendInvite(false)}
                  disabled={!email || !name}
                >
                  <div className="flex flex-row content-center">
                    <Space x={5} />
                    Inviter
                  </div>
                </PrimaryButton>
              </div>
            </div>
          </div>
        </Modal1>

        <div className="flex flex-col gap-2 h-fit  w-full pl-4 pb-80 ">
          <div className="text-h1 font-bold text-left  h-fit justify-between flex flex-row w-full">
            Entreprise{" "}
          </div>
          {false && (
            <TabGPT
              tabs={tabs}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            ></TabGPT>
          )}
          {/* Première colonne */}
          {activeTab === "infos" && (
            <div className="flex flex-col gap-2 max-w-c500 mt-2">
              <SaveBar
                condition={infos !== orgData.infos}
                onClick={callModifyMaster}
              />

              <div className="mb-4">
                <div className="text-h1 text-left font-medium mt-2 mb-4">
                  Logo entreprise
                </div>

                <div className="rounded-xl border-1 border-shadow_10 h-20 mb-2 w-c200 flex flex-row items-center">
                  {orgData.logo && (
                    <img
                      src={orgData.logo}
                      className="h-20 w-auto object-contain rounded-xl"
                    />
                  )}
                </div>
                <SecondaryButton
                  className={"w-fit h-fit"}
                  onClick={() => handleChangeLogo()}
                >
                  Ajouter un logo
                </SecondaryButton>
                {loadingFile && <Spin size="small" />}

                <div className="text-h1 font-medium  text-left mb-6 mt-10">
                  Informations de l'entreprise
                </div>
                <div className="flex flex-col gap-1 w-full">
                  <TextField2T
                    className="w-full text-left"
                    label="ID"
                    value={orgData.id}
                    disabled={true}
                  />
                  <TextField2T
                    className="w-full text-left"
                    label="Nom"
                    value={infos.name}
                    onChange={(e) =>
                      setInfos({ ...infos, name: e.target.value })
                    }
                  />
                  <TextField2T
                    className="w-full text-left"
                    label="Ville"
                    value={infos.city}
                    onChange={(e) =>
                      setInfos({ ...infos, city: e.target.value })
                    }
                  />
                  <TextField2T
                    className="w-full text-left"
                    label="Code postal"
                    value={infos.postal}
                    onChange={(e) =>
                      setInfos({ ...infos, postal: e.target.value })
                    }
                  />
                  <TextField2T
                    className="w-full text-left"
                    label="Adresse"
                    value={infos.address}
                    onChange={(e) =>
                      setInfos({ ...infos, address: e.target.value })
                    }
                  />{" "}
                  <TextField2T
                    className="w-full text-left"
                    label="Email"
                    value={infos.email}
                    onChange={(e) =>
                      setInfos({ ...infos, email: e.target.value })
                    }
                  />{" "}
                  <TextField2T
                    className="w-full text-left"
                    label="Téléphone"
                    value={infos.phone}
                    onChange={(e) =>
                      setInfos({ ...infos, phone: e.target.value })
                    }
                  />
                  <TextField2T
                    className="w-full text-left"
                    label="SIRET"
                    value={infos.siret}
                    onChange={(e) =>
                      setInfos({ ...infos, siret: e.target.value })
                    }
                  />
                </div>
              </div>
            </div>
          )}
          {/* Deuxième ligne pour les employés */}{" "}
          <div className="flex flex-col gap-2 max-w-c1p2k w-full px-4  mt-4">
            {activeTab === "members" && (
              <div className="w-full flex flex-col gap-2">
                <div className="text-h1 font-medium text-left flex flex-row gap-4 w-full">
                  Membres{" "}
                </div>
                <SecondaryButton
                  className="w-fit h-fit"
                  onClick={() => setAddMember(true)}
                >
                  Ajouter un membre
                </SecondaryButton>
                <div className="flex flex-col max-w-c1p2k w-full mt-2 rounded-xl ">
                  {users.map((user, index) => (
                    <div key={index}>
                      <NiceMemberBlock
                        last={index === users.length - 1}
                        user={user}
                        userData={userData}
                        orgData={orgData}
                        handleMemberClick={handleMemberClick}
                        handleSendInvite={handleSendInvite}
                      ></NiceMemberBlock>
                    </div>
                  ))}
                </div>
              </div>
            )}{" "}
          </div>{" "}
        </div>
      </div>{" "}
    </div>
  );
};
export default Organisation;

type NiceMemberBlockProps = {
  last?: boolean;
  user: User;
  handleMemberClick?: (user_id: string | undefined, isinfos: any) => void;
  orgData?: any;
  userData?: any;
  setMemberOpen?: (userId: string) => void;
  canopen?: boolean;
  show_id?: boolean;
  handleSendInvite?: (user_id: string | undefined) => void;
};

export const NiceMemberBlock = ({
  last = false,
  user,
  handleMemberClick,
  orgData,
  userData,
  setMemberOpen,
  canopen,
  handleSendInvite = () => {},
  show_id,
}: NiceMemberBlockProps) => {
  return (
    <div className={`flex flex-col p-2 w-full ${last ? " " : ""}`}>
      <div className="flex w-full flex-col ">
        <div className="flex flex-row gap-2 w-full items-center">
          <div className="relative">
            <div className="min-h-10 min-w-10 h-10 w-10 rounded-full bg-neutral-100" />
            <div
              className="absolute -bottom-1 -right-0 bg-white p-0.5
        rounded-full flex items-center justify-center"
            >
              <Icon1
                icon_name={user.org_admin ? "settings-filled" : ""}
                size={12}
                fill={user.org_admin ? "black" : "grey"}
              />
            </div>
          </div>
          <div className="w-full flex flex-row items-center">
            {/* Limiter la largeur du nom pour aligner les emails */}
            <div className="flex w-full max-w-c300 flex-col px-1">
              <div className="flex-1 font-medium text-h2   truncate">
                {user.display_name}
              </div>
              {/* Centrer l'email dans son div */}
              <div className="flex-1  text-h3 font-normal text-left">
                {user.email}
              </div>
              {show_id && (
                <div className="flex-1  text-h3 font-normal text-left">
                  {user.id}
                </div>
              )}
            </div>{" "}
            <SecondaryButton
              className="w-fit h-fit ml-2"
              onClick={() => handleSendInvite(user.id)}
            >
              Renvoyer l'invitation
            </SecondaryButton>
          </div>
        </div>
      </div>
    </div>
  );
};
